import { z, uuidSchema } from '@kc3/validation';
export const WidgetRatingSubmitSchema = z
    .object({
    callId: uuidSchema.optional(),
    conversationId: uuidSchema.optional(),
    score: z.number().int().min(1),
    comment: z.string().trim().min(1).max(2000).optional(),
})
    .refine((v) => (v.callId != null) !== (v.conversationId != null), {
    message: 'Exactly one of callId or conversationId must be provided',
});
//# sourceMappingURL=widget-rating.js.map